import React, { useState, useContext } from 'react';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { BACKEND_URL } from '../../../config/config';
import { NotificationContext } from '../../context/NotificationWrapper';
import { Button as CustomButton } from "../../misc/button/Button";

const DownloadReminderFilesButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { openNotification } = useContext(NotificationContext);

  const handleDownload = () => {
    setIsLoading(true);

    axios
      .get(`${BACKEND_URL}/api/admin/relances/download-latest`, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/zip',
        },
        responseType: 'blob',
      })
      .then((response) => {
        setIsLoading(false);

        // Créer un lien de téléchargement
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;

        // Nom du fichier avec la date du jour
        const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        link.setAttribute('download', `suivi_${date}.zip`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);

        openNotification(
          'Succès',
          'Les fichiers de relances ont été téléchargés avec succès',
          'success'
        );
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response?.status === 404) {
          openNotification(
            'Erreur',
            'Aucun fichier de relance disponible',
            'error'
          );
        } else if (error.response?.status === 403) {
          openNotification(
            'Erreur',
            'Accès non autorisé',
            'error'
          );
        } else {
          openNotification(
            'Erreur',
            'Erreur lors du téléchargement des fichiers de relances',
            'error'
          );
        }
      });
  };

  return (
    <CustomButton 
      title="Télécharger les fichiers de relances (déclarations manquantes et impayées)"
      children={<>Fichiers de relances <DownloadOutlined style={{marginLeft: 10}}/></>}
      onClick={handleDownload}
      isDisabled={isLoading}
    />
  );

  return (
    <Tooltip title="Télécharger les fichiers de relances (déclarations manquantes et impayées)">
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        onClick={handleDownload}
        loading={isLoading}
        style={{
          backgroundColor: '#ee463b',
          borderColor: '#ee463b',
          fontFamily: 'Quicksand',
          textTransform: 'uppercase',
          fontWeight: 'normal',
          minWidth: '200px',
        }}
      >
        Fichiers de relances
      </Button>
    </Tooltip>
  );
};

export default DownloadReminderFilesButton;
